import ButtonsHeader from "@/app/components/common/ButtonsHeader";
import { footerBg3Style } from "@/assets";

export default function ProfileEditSkeleton() {
  return (
    <>
      <ButtonsHeader heading="Profile" />
      <div className="flex items-center justify-center px-4 sm:px-6">
        <div className="h-24 w-24 animate-pulse rounded-full bg-[#F0E0C7]/60" />
      </div>
      <div
        className="mt-4 min-h-[calc(100vh-13.5rem)] rounded-t-3xl bg-white p-6 pb-10 sm:p-6 lg:mx-auto lg:max-w-2xl"
        style={footerBg3Style}
      >
        <div className="space-y-5">
          {Array.from({ length: 5 }).map((_, index) => (
            <div key={`profile-field-${index}`} className="space-y-2">
              <div className="h-4 w-24 animate-pulse rounded bg-[#F0E0C7]/60" />
              <div className="h-10 w-full animate-pulse rounded-lg bg-[#F0E0C7]/60" />
            </div>
          ))}
          <div className="h-11 w-full animate-pulse rounded-full bg-[#F0E0C7]/60" />
        </div>
      </div>
    </>
  );
}
